import { DASHBOARD_HS_STAFF } from "../apiConstant";
import BaseApi from "api/baseApi";

class HSStaffApi extends BaseApi {
  getDashboard() {
    return this.get(DASHBOARD_HS_STAFF);
  }
}

export default HSStaffApi;
